import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  Box,
  IconButton,
  ListItemButton
} from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SearchIcon from "@mui/icons-material/Search";
import DescriptionIcon from "@mui/icons-material/Description";
import SchoolIcon from "@mui/icons-material/School";
import EventIcon from "@mui/icons-material/Event";
import ChecklistIcon from "@mui/icons-material/Checklist";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import GroupsIcon from "@mui/icons-material/Groups";
import LogoutIcon from "@mui/icons-material/Logout";

import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";

const Sidebar = ({ open, onClose, onSearchOpen }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("uid");
    navigate("/login");
    onClose();
  };

  const handleNavClick = (path) => {
    navigate(path);
    onClose();
  };

  const handleBack = () => {
    navigate("/home");
    onClose();
  };

  const openCollegeExplorer = () => {
    onSearchOpen();
    onClose();
  };

  const openCollegePredictor = () => {
    navigate("/predict", { state: { openModal: Date.now() } });
    onClose();
  };

  /* ================= MENU DATA ================= */

  const menuItems = [
    { text: "Home", icon: <HomeIcon />, action: () => handleNavClick("/home"), path: "/home" },
    { text: "College Explorer", icon: <AccountBalanceIcon />, action: openCollegeExplorer },
    { text: "College Predictor", icon: <SearchIcon />, action: openCollegePredictor },
    { text: "Preference List Generator", icon: <DescriptionIcon />, action: () => handleNavClick("/preference-form"), path: "/preference-form" },
    { text: "Non CAP Admissions", icon: <SchoolIcon />, action: () => handleNavClick("/non-cap-admissions"), path: "/non-cap-admissions" },
    { text: "Admission Calendar", icon: <EventIcon />, action: () => handleNavClick("/calendar"), path: "/calendar" },
    { text: "Document Checklist", icon: <ChecklistIcon />, action: () => handleNavClick("/document-checklist"), path: "/document-checklist" },
    { text: "Learning Hub", icon: <PlayCircleIcon />, action: () => handleNavClick("/counseling"), path: "/counseling" },
    { text: "Counseling Program", icon: <GroupsIcon />, action: () => handleNavClick("/counselling-program"), path: "/counselling-program" }
  ];

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}

      ModalProps={{
        BackdropProps: {
          sx: {
            backgroundColor: "rgba(0,0,0,0.45)",
            backdropFilter: "blur(8px)"
          }
        }
      }}

      sx={{
  "& .MuiDrawer-paper": {
    width: { xs: 220, sm: 280 },
    background: "#f8fafc",
    borderRight: "1px solid #e5e7eb",
    boxShadow: "6px 0 20px rgba(0,0,0,0.2)"
  }
}}
    >

      {/* ================= HEADER ================= */}

      <Box
        sx={{
          background: "linear-gradient(135deg,#0a5aa8,#0b7fcf)",
          minHeight: 170,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
          position: "relative"
        }}
      >

        <IconButton
          onClick={handleBack}
          sx={{
            position: "absolute",
            top: 12,
            left: 12,
            color: "#fff"
          }}
        >
          <ArrowBackIcon />
        </IconButton>

        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: 2,
            background: "#fff",
            p: 1,
            mb: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <img src={logo} alt="Shooin Stars" style={{ width: 50 }} />
        </Box>

        <Typography
          variant="h6"
          fontWeight="bold"
          color="#fff"
          letterSpacing={0.6}
        >
          SHOOIN STARS
          <sup style={{ fontSize: 10 }}>™</sup>
        </Typography>

      </Box>

      <Divider />

      {/* ================= MENU ================= */}

      <List sx={{ px: 1, overflowY: "auto" }}>

        {menuItems.map((item, index) => {

          const active = location.pathname === item.path;

          return (
            <ListItem key={index} disablePadding>

              <ListItemButton
                onClick={item.action}
                sx={{
                  borderRadius: 2,
                  py: 1.5,
                  mb: 0.5,
                  backgroundColor: active ? "#e6f0ff" : "transparent",

                  "&:hover": {
                    backgroundColor: "#f1f5f9"
                  }
                }}
              >

                <ListItemIcon
                  sx={{
                    minWidth: 40,
                    color: active ? "#2563eb" : "#374151"
                  }}
                >
                  {item.icon}
                </ListItemIcon>

                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: 14,
                    fontWeight: active ? 600 : 500
                  }}
                />

              </ListItemButton>

            </ListItem>
          );
        })}

        {/* LOGOUT */}

        {user && (
          <>
            <Divider sx={{ my: 1 }} />

            <ListItem disablePadding>
              <ListItemButton
                onClick={handleLogout}
                sx={{
                  borderRadius: 2,
                  py: 1.5,
                  "&:hover": {
                    backgroundColor: "#fee2e2"
                  }
                }}
              >

                <ListItemIcon sx={{ minWidth: 40, color: "#dc2626" }}>
                  <LogoutIcon />
                </ListItemIcon>

                <ListItemText
                  primary="Logout"
                  primaryTypographyProps={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#dc2626"
                  }}
                />

              </ListItemButton>
            </ListItem>

          </>
        )}

      </List>

    </Drawer>
  );
};

export default Sidebar;